export const fetchCategories = ({ clientID }): Function => (
  state,
  actions,
): Promise<void> => {
  const { api } = state;

  if (state.categories.length) {
    return;
  }

  const headers = new Headers({ authorization: state.authorization });

  fetch(`${api}/v1/places/${clientID}/categories`, { headers })
    .then(response => response.json())
    .then(categories => actions.setCategories({ categories }));

  return {
    ...state,
    loadingCategories: true,
  };
};
